import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ThirdPartyCookies from './third-party-cookies/ThirdPartyCookies';
import GeoCheck from './geo-check/GeoCheck';
import DefaultCancellationPeriodError from './default-cancellation-period-error/DefaultCancellationPeriodError';
import DefaultTermedError from './default-termed-error/DefaultTermedError';
import DefaultSubscriptionIncompatibility from './default-subscription-incompatibility/DefaultSubscriptionIncompatibility';
import DefaultSubscriptionPaused from './default-subscription-paused/DefaultSubscriptionPaused';
import DefaultMultipleSubscription from './default-multiple-subscription/DefaultMultipleSubscription';
import {
	ROUTE_THIRD_PARTY_COOKIES,
	ROUTE_GEO_CHECK,
	ROUTE_MESSAGES_ERROR_CANCELLATION_PERIOD,
	ROUTE_MESSAGES_ERROR_TERMED,
	ROUTE_MESSAGES_ERROR_ALREADY_ACTIVATED,
	ROUTE_MESSAGES_ERROR_ALREADY_TRUSTED_PARTY,
	ROUTE_MESSAGES_ERROR_CANNOT_ACTIVATE,
	ROUTE_MESSAGES_ERROR_SUBSCRIPTION_CANCELLED_PARTNER,
	ROUTE_MESSAGES_ERROR_SUBSCRIPTION_INCOMPATIBILITY,
	ROUTE_MESSAGES_ERROR_SUBSCRIPTION_PAUSED,
	ROUTE_MESSAGES_ERROR_MULTIPLE_SUBSCRIPTION,
	ROUTE_MESSAGES_ERROR_INVALID_ENTITLEMENT,
	ROUTE_MESSAGES_ERROR_BLOCKED_OPEN_PAYMENT,
	ROUTE_MESSAGES_ERROR_SUBSCRIPTION_CANCELLED,
	ROUTE_MESSAGES_ERROR_ACTIVE_SUBSCRIPTION,
	ROUTE_MESSAGES_NEW_PLATFORM,
	ROUTE_MESSAGES_ERROR_BLACK_FRIDAY,
	ROUTE_MESSAGES_ERROR_LENTE_DEAL,
	ROUTE_MESSAGES_RESUME_PENDING_PAYMENT,
	ROUTE_MESSAGES_ERROR_INACTIVE_USER,
	ROUTE_MESSAGES_ERROR_TERMED_NPL,
} from '../../../constants/Routes';
import DefaultAlreadyTrustedParty from './default-already-trusted-party/DefaultAlreadyTrustedParty';
import DefaultTrustedPartyInvalid from './default-trusted-party-invalid/DefaultTrustedPartyInvalid';
import DefaultTrustedPartyCannotActivate from './default-trusted-party-cannot-activate/DefaultTrustedPartyCannotActivate';
import DefaultTrustedPartyAlreadyClaimed from './default-trusted-party-already-claimed/DefaultTrustedPartyAlreadyClaimed';
import DefaultSubscriptionCancelledError from './default-subscription-cancelled-error/DefaultSubscriptionCancelledError';
import BlockedOpenPayment from './blocked-open-payment/BlockedOpenPayment';
import SubscriptionCancelledInvoices from './subscription-cancelled-invoices/SubscriptionCancelledInvoices';
import DefaultActiveSubscription from './default-active-subscription/DefaultActiveSubscription';
import NewPlatform from './new-platform/NewPlatform';
import ResumePendingPayment from './resume-pending-payment/ResumePendingPayment';
import DefaultInactiveUserError from './default-inactive-user-error/DefaultInactiveUserError';
import DealIsVoorbij from './deal-is-voorbij/DealIsVoorbij';

export default ({ location }) => {
	return (
		<Switch location={location}>
			<Route path={ROUTE_GEO_CHECK} exact component={GeoCheck} />
			<Route path={ROUTE_THIRD_PARTY_COOKIES} exact component={ThirdPartyCookies} />
			<Route
				path={ROUTE_MESSAGES_ERROR_BLOCKED_OPEN_PAYMENT}
				exact
				component={BlockedOpenPayment}
			/>
			<Route
				path={ROUTE_MESSAGES_ERROR_CANCELLATION_PERIOD}
				exact
				component={DefaultCancellationPeriodError}
			/>
			<Route path={ROUTE_MESSAGES_ERROR_TERMED} exact component={DefaultTermedError} />
			<Route
				path={ROUTE_MESSAGES_ERROR_TERMED_NPL}
				exact
				render={(props) => <DefaultTermedError {...props} isNPL />}
			/>
			<Route
				path={ROUTE_MESSAGES_ERROR_ALREADY_ACTIVATED}
				exact
				component={DefaultTrustedPartyAlreadyClaimed}
			/>
			<Route
				path={ROUTE_MESSAGES_ERROR_ALREADY_TRUSTED_PARTY}
				exact
				component={DefaultAlreadyTrustedParty}
			/>
			<Route
				path={ROUTE_MESSAGES_ERROR_INVALID_ENTITLEMENT}
				exact
				component={DefaultTrustedPartyInvalid}
			/>
			<Route
				path={ROUTE_MESSAGES_ERROR_CANNOT_ACTIVATE}
				exact
				component={DefaultTrustedPartyCannotActivate}
			/>
			<Route
				path={ROUTE_MESSAGES_ERROR_SUBSCRIPTION_CANCELLED_PARTNER}
				exact
				component={DefaultSubscriptionCancelledError}
			/>
			<Route
				path={ROUTE_MESSAGES_ERROR_SUBSCRIPTION_CANCELLED}
				exact
				component={SubscriptionCancelledInvoices}
			/>
			<Route
				path={ROUTE_MESSAGES_ERROR_SUBSCRIPTION_INCOMPATIBILITY}
				exact
				component={DefaultSubscriptionIncompatibility}
			/>
			<Route
				path={ROUTE_MESSAGES_ERROR_SUBSCRIPTION_PAUSED}
				exact
				component={DefaultSubscriptionPaused}
			/>
			<Route
				path={ROUTE_MESSAGES_ERROR_MULTIPLE_SUBSCRIPTION}
				exact
				component={DefaultMultipleSubscription}
			/>
			<Route
				path={ROUTE_MESSAGES_ERROR_ACTIVE_SUBSCRIPTION}
				exact
				component={DefaultActiveSubscription}
			/>
			<Route path={ROUTE_MESSAGES_ERROR_INACTIVE_USER} exact component={DefaultInactiveUserError} />
			<Route path={ROUTE_MESSAGES_NEW_PLATFORM} exact component={NewPlatform} />
			<Route
				path={ROUTE_MESSAGES_ERROR_BLACK_FRIDAY}
				exact
				render={(props) => <DealIsVoorbij {...props} />}
			/>
			<Route
				path={ROUTE_MESSAGES_ERROR_LENTE_DEAL}
				exact
				render={(props) => <DealIsVoorbij {...props} isLenteDeal />}
			/>
			<Route path={ROUTE_MESSAGES_RESUME_PENDING_PAYMENT} exact component={ResumePendingPayment} />
		</Switch>
	);
};
